import autobind from "autobind-decorator";
import debounce from "lodash/debounce";
import React, { Component } from "react";
import CSSModules from "react-css-modules";
import { Link } from "react-router";

import SSOActions from "actions/Global/SSOActions";
import DocumentTitle from "components/Global/DocumentTitle";
import Helpers from "utils/Global/Helpers";
import ViewWrapper from "views/Auth/ViewWrapper";

import css from "./styles.scss";

import { LOGIN_RETURN_TO_KEY } from "../LoginView";

const DEBOUNCE_DELAY = 500;

@CSSModules(css)
class SSOHandler extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: props.location.query.email || "",
      message: this.props.location.query.message || null,
      identityProviders: [],
      complete: false,
      isSignupFlow: props.location.query.signup === "true" ? true : false
    };
  }

  componentDidMount() {
    if (this.props.location.query.email) {
      this.handleSubmit(this.props.location.query.email);
    }

    this.setLoginReturnToUrl();
  }

  setLoginReturnToUrl = () => {
    if (this.props.location.query && this.props.location.query.returnTo) {
      localStorage.setItem(
        LOGIN_RETURN_TO_KEY,
        this.props.location.query.returnTo
      );
    } else {
      // Ensure there is nothing left over that is stored
      localStorage.removeItem(LOGIN_RETURN_TO_KEY);
    }
  };

  debouncedFetchIdentityProviders = debounce(email => {
    SSOActions.getSSOEntryPoint(encodeURIComponent(email), response => {
      if (response.success) {
        const { payload } = response;

        this.setState({
          identityProviders: payload,
          message: null
        });
      } else {
        this.setState({
          message: (
            <span>
              Oops... the domain couldn&#39;t be found. Please reach out to the
              organization administrator to set it up.
            </span>
          )
        });
      }
    });
  }, DEBOUNCE_DELAY);

  @autobind
  handleSubmit(email) {
    this.setState({
      email
    });

    const domainPattern = /[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+/;

    if (domainPattern.test(email) || Helpers.isValidEmail(email)) {
      this.debouncedFetchIdentityProviders(email);
    } else {
      this.setState({
        identityProviders: [],
        message: null
      });
    }
  }

  render() {
    return (
      <DocumentTitle title="SSO">
        <ViewWrapper>
          <div styleName="container">
            <div styleName="title">
              {this.state.isSignupFlow
                ? `Complete your sign up with Single Sign-On`
                : `Login with Single Sign-On`}
            </div>

            {this.state.complete ? (
              <span>
                <div styleName="successContainer">
                  <i className="material-icons">check</i>
                  <div>
                    <div styleName="header">Awesome!</div>
                    <div styleName="body">{this.state.message}</div>
                  </div>
                </div>
                <Link to="/login" styleName="goBackBlack">
                  <i className="material-icons">arrow_back</i>
                  Back to sign in
                </Link>
              </span>
            ) : (
              <span>
                <div styleName="caption">
                  Enter your email or company domain to continue
                </div>
                <form>
                  <div styleName="inputWrapper">
                    <input
                      className="styled"
                      type="text"
                      placeholder="example.com"
                      value={this.state.email}
                      required
                      autoFocus
                      onChange={e => {
                        e.preventDefault();
                        this.handleSubmit(e.target.value);
                      }}
                      ref="email"
                    />
                  </div>

                  {this.state.message && (
                    <div styleName="message">{this.state.message}</div>
                  )}

                  <ul>
                    {this.state.identityProviders.map(identityProvider => {
                      return (
                        <li style={{ marginBottom: "5px" }}>
                          <button
                            styleName="buttonWrapper"
                            type="button"
                            onClick={e => {
                              e.preventDefault();

                              this.setState({
                                message:
                                  "Redirecting to your Identity Provider...",
                                complete: true
                              });

                              setTimeout(() => {
                                window.location.replace(
                                  identityProvider.sso_url
                                );
                              }, 1000);
                            }}
                          >
                            <span styleName="button">
                              {this.state.isSignupFlow ? (
                                <>
                                  Sign up with{" "}
                                  {identityProvider.vendor_app_name}
                                </>
                              ) : (
                                <>
                                  Login with {identityProvider.vendor_app_name}
                                </>
                              )}
                            </span>
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                  {this.state.isSignupFlow ? null : (
                    <>
                      {this.state.identityProviders.length > 0 && (
                        <div style={{ textAlign: "center", marginTop: "20px" }}>
                          - or -
                        </div>
                      )}
                      <Link to="/login" styleName="goBack">
                        <i className="material-icons">arrow_back</i>
                        More ways to sign in
                      </Link>
                    </>
                  )}
                </form>
              </span>
            )}
          </div>
        </ViewWrapper>
      </DocumentTitle>
    );
  }
}
export default SSOHandler;
